import {
  InfoIcon,
  DocumentIcon,
  PhoneIcon,
  MapPinIcon,
  ChartIcon,
  ShieldIcon,
  StarIcon,
} from "../../../assets/ui/icons";

/* Which mark goes beside a company profile change. */
export const UPDATE_ICON_RULES = [
  /* Verification before membership: "Verified Member badge" is a verification
     event, not a membership one. */
  [/verif|approved/i, ShieldIcon],
  [/member|subscription|upgraded to a paid/i, StarIcon],
  [/licen[cs]e|report|certificat|document|filing|registration/i, DocumentIcon],
  [/financial|statement|turnover|revenue|balance sheet|figures/i, ChartIcon],
  [/address|office|location|premises|branch/i, MapPinIcon],
  [/phone|mobile|telephone|contact number|contact detail/i, PhoneIcon],
  [/claim/i, ShieldIcon],
];

/* The mark for one update. Neutral when nothing matches — never empty. */
export const iconForUpdate = (content) => {
  const text = typeof content === "string" ? content : "";
  const rule = UPDATE_ICON_RULES.find(([pattern]) => pattern.test(text));
  return rule ? rule[1] : InfoIcon;
};

export default iconForUpdate;
